import { CheckCircle, Package, ClipboardCheck, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export function InventoryCompletedView({
  location,
  products,
  loading,
  onNewInventory,
}) {
  const totalQuantity = products.reduce((sum, p) => sum + (p.antal || 0), 0);

  return (
    <div className="max-w-2xl mx-auto space-y-4" data-testid="inventory-completed-view">
      <Card className="border-green-500/30 bg-green-500/5">
        <CardContent className="p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 rounded-full bg-green-500/10">
              <CheckCircle className="h-6 w-6 text-green-500" />
            </div>
            <div>
              <h2 className="text-xl font-bold">Inventering slutförd</h2>
              <p className="text-muted-foreground">
                Lagerplats: <span className="font-mono font-bold text-foreground">{location}</span>
              </p>
            </div>
          </div>
          
          <div className="border-t border-border pt-4 mt-4">
            <h3 className="text-sm font-medium text-muted-foreground mb-3 flex items-center gap-2" data-testid="inventory-completed-totals">
              <Package className="h-4 w-4" />
              Produkter på lagerplatsen ({products.length} unika, {totalQuantity} st totalt)
            </h3>
            
            {loading ? (
              <div className="flex items-center justify-center py-8">
                <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
              </div>
            ) : products.length === 0 ? (
              <p className="text-muted-foreground text-center py-4">Inga produkter på denna lagerplats</p>
            ) : (
              <div className="space-y-2 max-h-80 overflow-y-auto">
                {products.map((product, index) => (
                  <div 
                    key={product.id || index}
                    className="flex items-center justify-between p-3 bg-card rounded-lg border border-border"
                    data-testid={`inventory-completed-row-${product.ean || index}`}
                  >
                    <div>
                      <p className="font-medium">{product.artikelnummer || product.ean}</p>
                      {product.produktnamn && (
                        <p className="text-sm text-muted-foreground">{product.produktnamn}</p>
                      )}
                    </div>
                    <Badge variant="outline" className="font-mono">
                      {product.antal} st
                    </Badge>
                  </div>
                ))}
              </div>
            )}
          </div>
          
          <div className="mt-6 pt-4 border-t border-border">
            <Button 
              onClick={onNewInventory}
              className="w-full"
              data-testid="new-inventory-btn"
            >
              <ClipboardCheck className="h-4 w-4 mr-2" />
              Inventera ny lagerplats
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
